import React from 'react'
import UserAccountForm from '../components/User/UserAccountForm'
const Profile = () => {
    return <UserAccountForm />
}

export { Profile }